import cn from 'classnames';
import React from 'react';
import Button from './Button';
import {ButtonColour} from './ButtonColour';

type Props = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  short?: boolean
  className?: string,
  colour?: ButtonColour
  to?: string
}

export default function TextButton({
  onClick, short, className, colour = ButtonColour.BLUE, to, ...props
}: React.PropsWithChildren<Props>) {
  return (
    <Button onClick={onClick} short={short} narrow={true} to={to}
      className={cn(
        className,
        {'text-blue hover:text-blue-hover focus:ring-blue active:text-blue-press': colour !== ButtonColour.RED},
        {'text-red hover:text-red-hover focus:ring-red active:text-red-press': colour === ButtonColour.RED},
        'px-4 focus:outline-none',
      )}>
      {props.children}
    </Button>
  );
}
